import React from "react";
import styles from "./Form.module.css";
import SearchDropdown from "../../../Reusable/SearchDropdown/SearchDropdown";
import Autocomplete from "react-google-autocomplete";

const FormSection = ({
  label,
  icon,
  inputType,
  placeholder,
  value,
  onChange,
  onClick,
  isDateTime,
  type,
  preInput,
  setVenue
}) => {
  return (
    <section
      className={styles.formSection}
      style={{ marginTop: isDateTime ? "0px" : undefined }}
    >
      <label className={styles.formLabel}>
        {label}
      </label>
      <div className={styles.formInputWrapper}>
        {type ? (
          <SearchDropdown 
            type={type}
            placeholder={placeholder}
            onSelect={(value) => onChange({ target: { value } })}
            icon={icon}
            isMultiple={type === 'players' ? true : false}
            oldValue = {value}
            preInput = {preInput}
          />
        ) :
        label === "Choose venue *" ? 
        (
          <>
          <span className={styles.formIcon} aria-hidden="true">
              {icon}
            </span>

            <Autocomplete
              apiKey={ process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
              onPlaceSelected={(places) => {setVenue(places.formatted_address)}}
              className={styles.formInput}
            />
          </>
        ): (
          <>
            <span className={styles.formIcon} aria-hidden="true">
              {icon}
            </span>
            <input
              type={inputType}
              className={styles.formInput}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              aria-label={label}
              onClick={onClick}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default FormSection;